const load = (component) => () => import(`@/views/${component}.vue`);

export default [
  {
    path: 'dev',
    name: 'dev',
    component: load('dev/UIShowcase'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: 'dev/components',
    name: 'dev-components',
    component: load('dev/ComponentsRegistry'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: 'dev/materials',
    name: 'dev-materials',
    component: load('dev/MaterialsDev'),
    meta: {
      requiresAuth: false,
    },
  },
];
